/*
 * Copyright 2012 Sagarana Tech.  All rigths reserved.
 *
 * This software is the confidential and proprietary information of
 * Sagarana Tech ("Confidential Information"). You shall not disclose such
 * Confidential Information and shall use it only in accordance with the
 * terms of the license agreement you entered into with Sagarana Tech.
 *
 */

/**
 * Controla todo o sistema de notificações e mensagens do Monet.
 *
 * @author Mozart Diniz mozartdiniz@sagaranatech.com
 * Date: 16/03/2013
 * Time: 10:47
 *
 */

Monet.Form.Messages = {

  mountErrorMessageObject: (key, valueInResource = null) => ({
    resource: {
      i18nMessage: Monet.I18n.getResourcesByKey(key, valueInResource)
    }
  }),
  getErrorMessageToBeDisplayed : (errorMessages) => {
    //if errorMessages has more than a single element, return an error messages string array
    if (errorMessages?.length > 1) {
      let messagesArray = [];
      for (let i = 0; i < errorMessages.length; i++) {
        if (errorMessages[i].resource.i18nMessage) {
          messagesArray.push(errorMessages[i].resource.i18nMessage);
        } else {
          messagesArray.push(Monet.I18n.getResourcesByKey(errorMessages[i].resource.key));
        }
      }
      return messagesArray;
    } else if (errorMessages?.length === 1) {
        if (errorMessages[0].resource.i18nMessage) {
          return errorMessages[0].resource.i18nMessage;
        } else {
          return Monet.I18n.getResourcesByKey(errorMessages[0].resource.key);
        }
    }
  }
};

Monet.Form.Messages.Base = function () {

		// O universo no DOM onde a classe deverá procurar pela estrutura onde as mensagens
		// serão exibidas, só faz sentido no tipo de mensagem inline.
		this.scope = null;

		/**
		 * messageType é o tipo de mensagem que será exibida, pode serm:
		 *     inline: é a mensagem que fica gravada no formulário
		 *     alert: é exibido um alerta com o texto a ser alertado
		 */

		this.messageType = "alert";

		/**
		 * infoType é a natureza da mensage a ser exibida, exemplo:
		 *      info: apenas informações ao usuário, azul
		 *      error: validações que falharam ou erros que ocorreram, vermelho
		 * 			success: validações e requisições finalzadas com sucesso, verde
		 */

		this.infoType = "info";

		// inicialização do array de mensagens que será retornado ao final dos tratamentos
		this.messages = null;

		this.setMessageType = function (messageType) {
				this.messageType = messageType;
		};

		this.setMessage = function (message) {
				this.message = message;
		};

		this.setInfoType = function (infoType) {
				this.infoType = infoType;
		};

		this.setScope = function (scope) {
				this.scope = scope;
		};

		/**
		 * Caso tenha sido passado uma lista de mensagens no objeto, essa função transforma todas
		 * em um texto com quebra de linha e exibe
		 */

		this.makeMessageTextFromArray = (errorMessages) => {

				this.messageText = "";

				if (errorMessages.length > 1) {

					const errorMessagesArray = Monet.Form.Messages.getErrorMessageToBeDisplayed(errorMessages);

                    this.messageText = errorMessagesArray.reduce(
                        (anteriorValue, actualValue) => ( anteriorValue += `<li>${actualValue}</li>` )
                    , this.messageText);

				} else {
						this.messageText = Monet.Form.Messages.getErrorMessageToBeDisplayed(errorMessages);
				}

				return this.messageText;
		};

};

/**
 * Exibe as mensagens do sistema como forma de alerta
 *
 */

Monet.Form.Messages.AlertMessage = (function () {

		AlertMessage.prototype = new Monet.Form.Messages.Base();

		function AlertMessage() {
				let error;
				//Dispara o alerta, retorna falso caso nada tenha sido passado
				this.triggerMessage = function () {
						if(this.message) {
								if (this.message.errorMessages && this.message.errorMessages.length) {

									new Greenmile.Components.AlertModal(this.makeMessageTextFromArray(this.message.errorMessages))
										.show();

								}
								else {
										error = new Monet.Exception.ReturnError(this, "No error message found");
										error.console();
								}
						}
						else {
							error = new Monet.Exception.ReturnError(this, "Message object is undefined");
							error.console();
						}
				};

		};

		return AlertMessage;

})();

/**
 * Exibe as mensagens do sistema em uma div em cima do formulário, a cor da div varia de acordo
 * com a natureza da mensagem
 *
 */

Monet.Form.Messages.InlineMessage = (function () {

	InlineMessage.prototype = new Monet.Form.Messages.Base();

	function InlineMessage() {
		let error = null;

		/**
		 * Verifica se o html que marca o lugar onde as mensagens serão gravadas existe, se não
		 * existir retorna false;
		 */
		this.checkHTMLContainer = function () {
			let htmlContainer = null;
			if (this.parentNode) {
				htmlContainer = this.parentNode.querySelector("div.monetInlineAlerContainer");
			} else {
				if (this.scope === null) {
					error = new Monet.Exception.ReturnError(this, "No scope defined");
					error.console();
					return false;
				}
	
				htmlContainer = document.querySelector(this.scope + " div.monetInlineAlerContainer");
			}

			if (htmlContainer === null) {
				error = new Monet.Exception.ReturnError(this, "No message container found");
				error.console();
				return false;
			}

			return htmlContainer;
		};

		/**
		 * Grava a estrutura básica para que as mensagens sejam escritas.
		 */
		this.writeBaseHTML = function () {
			this.htmlContainer = this.checkHTMLContainer();

			if (this.htmlContainer) {
				const template = new Monet.UI.LayoutGenerator({
					items: [{
						attributes: {
							"class": `monet-message alert alert-${this.infoType}`,
						},
						items: [
							{
								tag: "button",
								attributes: {
									class: "monet-message__btn-close"
								},
								html: "×"
							},
							{
								attributes: {
									"class": "message-content"
								}
							}
						]
					}]
				}).render();

				this.messageContent = template.querySelector(".message-content");

				const closeBtn = template.querySelector(".monet-message__btn-close");
				closeBtn && closeBtn.addEventListener("click", (ev) => {
					ev.preventDefault();
					const alertMessage = ev.target.parentElement;
					alertMessage && alertMessage.parentElement.removeChild(alertMessage);
				});

				this.htmlContainer.innerHTML = "";
				this.htmlContainer.appendChild(template);

				return true;
			}
			return false;
		};

		this.makeMultiplesLines = function (inputs, msg) {
			var message = "";
			inputs.forEach(function (input) {
				message += "<li>" + Monet.I18n.getResourcesByKey(input) + ": " + msg + "</li>";
			});
			return message;
		};

		this.getMessageContent = function () {
			let error;

			if (this.message) {
				if (this.message.errorMessages && this.message.errorMessages.length) {
					return this.makeMessageTextFromArray(this.message.errorMessages);
				} else if (typeof this.message === 'string') {
					return this.message;
				} else {
					error = new Monet.Exception.ReturnError(this, "No error message found");
					error.console();
				}
			}
			else {
				error = new Monet.Exception.ReturnError(this, "Message object is undefined");
				error.console();
			}
			return '';
		};

		// Em alguns lugares não existe um seletor único, e sim um NODE onde as mensagens irão aparecer. Nesse caso, deve-se informar qual o NODE
		this.setParentNode = (node) => {
			this.parentNode = node;
		};

		this.destroy = () => {
			this.htmlContainer.innerHTML = "";
		}

		//Dispara o alerta, retorna falso caso nada tenha sido passado
		this.triggerMessage = function () {
			var hasBaseHTML = this.writeBaseHTML();
			var error = null;

			if (hasBaseHTML) {
				this.messageContent.innerHTML = this.getMessageContent();
			} else {
				error = new Monet.Exception.ReturnError(this, "There's no minimal structure to write Monet Messages");
				error.console();
			}
		};
	};

	return InlineMessage;
})();
